export const getTagArray = (tags: ResourceTags) => {
  switch (true) {
    case Array.isArray(tags) && typeof tags[0] === 'string':
      return tags;
    case tags && 'value' in tags && typeof tags.value === 'object':
      return [tags.value.data.label];
    default:
      return null;
  }
};
